import { defineMessages } from '@jutro/locale';

export default defineMessages({
    addNote: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.Add Note',
        defaultMessage: 'Add Note'
    },
    cancelModal: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.CANCEL',
        defaultMessage: 'CANCEL'
    },
    date: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.Date',
        defaultMessage: 'Date'
    },
    accountNumber: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.Account Number',
        defaultMessage: 'Account Number'
    },
    category: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.Category',
        defaultMessage: 'Category'
    },
    description: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.Description',
        defaultMessage: 'Description'
    },
    fullDescription: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.Full Description',
        defaultMessage: 'Full Description'
    },
    author: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.Author',
        defaultMessage: 'Author'
    },
    noteDetails: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.Note Details',
        defaultMessage: 'Note Details'
    },
    closeBtnLabel: {
        id: 'ml.gateway.WizardSidebar.NoteDetailsPopup.CLOSE',
        defaultMessage: 'CLOSE'
    }
});
